import "./Blog.module.css";
import TopBarMainNavigation from "@/reusable_sections/Header";
import BlogHero from "./sections/BlogHero";
import BlogPosts from "./sections/BlogPosts";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <TopBarMainNavigation />
      <BlogHero />
      <BlogPosts />
      <Footer />
    </div>;
}